import { Button as AntdButton } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';

type ButtonProps = AntdButtonProps & {
  children?: React.ReactElement | string | React.ReactNode;
};

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { children, ...otherProps } = props;
  return <AntdButton {...otherProps}>{children}</AntdButton>;
};

export default Button;
